<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <vs-popup class="holamundo" title="انتخاب درگاه" :active.sync="popupActive">
    <div
      :key="indextr"
      v-for="(tr, indextr) in items"
      :style="indextr == 1 ? 'background: #f8f8f8!important;' : ''"
      class="cursor-pointer py-2 px-3"
      @click="select1(tr)"
    >
      <feather-icon
        :title="MerchantType[tr.merchantType].title"
        :icon="MerchantType[tr.merchantType].icon"
        :svgClasses="[`h-6 w-6 stroke-current `]"
      ></feather-icon>
      {{ tr.label }}({{ tr.website }})
    </div>
    <hr />
    <p class="text-center text-sm">
      جهت تعریف درگاه جدید به
      <router-link to="/merchant/gateways"> درگاه‌های من </router-link> بروید
    </p>
  </vs-popup>
</template>
<style>
</style>
<script>
import vSelect from "vue-select";
import { MerchantType } from "@/enums.js";
export default {
  name: "select-account-popup",
  data() {
    return {
      _userId1: "currentUser",
      popupActive: false,
      MerchantType
    };
  },
  computed: {
    items() {
      if (!this.$store.getters["account/items"][this._userId1]) return [];
      if (this.showConsumerAccount)
        return this.$store.getters["account/items"][this._userId1];
      else
        return this.$store.getters["account/items"][this._userId1].filter(
          (x) => x.isMerchant
        );
    },
  },
  methods: {
    show() {
      this.popupActive = true;
    },
    select1(val) {
      this.$store.dispatch("account/setDefault", {
        id: val.value,
        text: val.label,
      });
      this.popupActive = false;
    },
  },
  mounted() {
    this._userId1 = "currentUser";
    this.$store.dispatch("account/fetchItems", { userId: this._userId1 });
  },
};
</script>
